import { render, staticRenderFns } from "./FormImageText.vue?vue&type=template&id=5722b3b2&"
import script from "./FormImageText.vue?vue&type=script&lang=js&"
export * from "./FormImageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports